import React from 'react';
import { Button, Table, InputNumber, Input } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import { FG112 } from '../../../services/pwg201Api';

interface Props {
  rows: FG112[];
  isEditing: boolean;
  onChange: (rows: FG112[]) => void;
}

const WriteoffAdvTab: React.FC<Props> = React.memo(({ rows, isEditing, onChange }) => {
  const addRow = () => {
    onChange([
      ...rows,
      { fg112_01: '', fg112_02: rows.length + 1, fg112_11: '', fg112_12: 'NTD', fg112_13: 0, fg112_14: 0, fg112_90: 0 },
    ]);
  };

  const deleteRow = (idx: number) => onChange(rows.filter((_, i) => i !== idx));

  const updateRow = (idx: number, field: keyof FG112, value: any) => {
    const updated = [...rows];
    (updated[idx] as any)[field] = value;
    onChange(updated);
  };

  const columns: ColumnsType<FG112> = [
    { title: <span data-contract-field="fg112_02">序</span>, dataIndex: 'fg112_02', width: 50 },
    {
      title: <span data-contract-field="fg112_11">預收款單號</span>,
      dataIndex: 'fg112_11',
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} onChange={e => updateRow(i, 'fg112_11', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg112_12">幣別</span>,
      dataIndex: 'fg112_12',
      width: 70,
      render: (v, _, i) =>
        isEditing ? (
          <Input size="small" value={v} maxLength={3} onChange={e => updateRow(i, 'fg112_12', e.target.value)} />
        ) : v,
    },
    {
      title: <span data-contract-field="fg112_13">沖銷金額</span>,
      dataIndex: 'fg112_13',
      width: 120,
      render: (v, _, i) =>
        isEditing ? (
          <InputNumber size="small" value={v} style={{ width: '100%' }} onChange={val => updateRow(i, 'fg112_13', val ?? 0)} />
        ) : v,
    },
    ...(isEditing
      ? [{
          title: '',
          width: 40,
          render: (_: any, __: FG112, i: number) => (
            <Button type="text" danger icon={<DeleteOutlined />} size="small" onClick={() => deleteRow(i)} />
          ),
        }]
      : []),
  ];

  return (
    <div>
      <Table size="small" columns={columns} dataSource={rows} rowKey={(_, i) => `adv-${i}`} pagination={false} />
      {isEditing && (
        <Button icon={<PlusOutlined />} onClick={addRow} style={{ marginTop: 8 }}>
          新增沖預收款
        </Button>
      )}
    </div>
  );
});

export default WriteoffAdvTab;
